"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSingleFile = fetchSingleFile;
exports.fetchSingleFileIfNeeded = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _ActionTypes = require("./ActionTypes");

var FilesApi = _interopRequireWildcard(require("../api/Files"));

var _logging = require("../utils/logging");

var _FileDetails = require("../selectors/FileDetails");

var getFetchSingleFileFailedNotification = function getFetchSingleFileFailedNotification() {
  return {
    'data-test-id': 'single-file-fetch-failed',
    type: 'danger',
    titleText: _I18n.default.text('FileManagerCore.notifications.fetchSingleFile.error.title')
  };
};

var getFetchSingleFileFailed = function getFetchSingleFileFailed(fileId) {
  return {
    type: _ActionTypes.FETCH_SINGLE_FILE_FAILED,
    fileId: fileId,
    meta: {
      notification: getFetchSingleFileFailedNotification()
    }
  };
};

var getFetchSingleFileAttempted = function getFetchSingleFileAttempted(fileId) {
  return {
    type: _ActionTypes.FETCH_SINGLE_FILE_ATTEMPTED,
    fileId: fileId
  };
};

var getFetchSingleFileSuccess = function getFetchSingleFileSuccess(fileId, file) {
  return {
    type: _ActionTypes.FETCH_SINGLE_FILE_SUCCESS,
    fileId: fileId,
    file: file
  };
};

function fetchSingleFile(fileId) {
  return function (dispatch) {
    dispatch(getFetchSingleFileAttempted(fileId));
    return FilesApi.fetchSingleFile(fileId).then(function (file) {
      dispatch(getFetchSingleFileSuccess(fileId, file));
      return file;
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        type: _ActionTypes.FETCH_SINGLE_FILE_FAILED
      });
      dispatch(getFetchSingleFileFailed(fileId));
      throw err;
    });
  };
}

var fetchSingleFileIfNeeded = function fetchSingleFileIfNeeded(fileId) {
  return function (dispatch, getState) {
    var singleFileDetails = (0, _FileDetails.getSingleFileDetails)(getState());

    if (singleFileDetails.get(fileId)) {
      return Promise.resolve(singleFileDetails.get(fileId));
    }

    return dispatch(fetchSingleFile(fileId));
  };
};

exports.fetchSingleFileIfNeeded = fetchSingleFileIfNeeded;